<template>
    <div>
        <top-navbar :breadcrumb="breadcrumb"></top-navbar>

        <div class="container-fluid mt--6">
            <div class="row">
                <div class="col">
                    <import-logs type="cohorts"></import-logs>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ImportLogs from './imports/ImportLogs';

    export default {

        components: {
            ImportLogs
        },

        computed: {

            breadcrumb() {
                return [
                    {
                        name: this.$t('common.cohorts'),
                        route: '/socrates/ui/accounts/cohorts'
                    },
                    {
                        name: this.$t('common.import'),
                    },
                ]
            }
        },
    }
</script>
